module.exports = __webpack_public_path__ + "static/media/varisa.bc70c2b0.jpg";